/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export default {
    TYPE_AREA: 'area',
    TYPE_FIELD: "field",
    TYPE_RADIO: "radio",
    TYPE_DROP_DOWN: "drop_down",
    TYPE_CHECK_BOX: "checkbox",
    TYPE_MULTIPLE: "multiple",
    TYPE_DATE: "date",
    TYPE_TIME: "time",
    TYPE_DATE_TIME: "date_time",

    PRICE_TYPE_FIXED: "fixed",
    PRICE_TYPE_PERCENT: "percent",
}



// WEBPACK FOOTER //
// ./src/view/constant/catalog/OptionConstant.js